export default Object.freeze({
	onDeviceReady() {
	}
});